// flow
import * as React from 'react';
import ErrorModal from 'components/api/containers/ErrorModal/ErrorModal';
import { getFormattedMessageTag } from 'utils/string';

import './QuoteApptError.scss';

class QuoteApptError extends React.Component {
  static block = 'quote-appt-error';

  constructor(props, context) {
    super(props, context);
    this.modal = React.createRef();
  }

  setShowModal = (show = true) => {
    this.modal.current.setShowModal(show);
  };

  render() {
    const { ...otherProps } = this.props;
    const ns = QuoteApptError.block;
    return (
      <ErrorModal
        ref={this.modal}
        icon={() => {}}
        content={() => (
          <div className={ns}>
            <div className={`${ns}__title`}>
              {getFormattedMessageTag(
                'c8.quote.error.not.available',
                'This quote is no longer available.'
              )}
            </div>
            <div className={`${ns}__message`}>
              {getFormattedMessageTag(
                'c8.quote.error.please.contact.dealership',
                'Please contact your dealership for more information.'
              )}
            </div>
          </div>
        )}
        {...otherProps}
      />
    );
  }
}

export default QuoteApptError;



// WEBPACK FOOTER //
// ./src/components/api/components/QuoteApptError/QuoteApptError.js